module.exports = __webpack_public_path__ + "static/media/FJ.390bc160.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/FJ.svg
// module id = 251
// module chunks = 0